import { Auth } from '@aws-amplify/auth';
import { Box, Button, Divider } from '@mui/material';
import { useCallback } from 'react';
import CFRALogo from 'assets/images/cfra_logo.svg';
import {
    navBarSx,
    navDividerSx,
    navLogoGroupSx,
    navLogoSx,
    navSignOutSx,
} from './topNavigation.styles';
import { NavTitleTypography } from './topNavigation.typography';

export function TopNavigation() {
    const handleSignOut = useCallback(async () => {
        try {
            await Auth.signOut();
            window.location.href = '/';
        } catch (error) {
            console.error('Sign out error:', error);
        }
    }, []);

    return (
        <Box component='header' role='banner' sx={navBarSx}>
            <Box sx={navLogoGroupSx}>
                <Box component='img' src={CFRALogo} alt='CFRA' sx={navLogoSx} />
                <Divider orientation='vertical' flexItem sx={navDividerSx} />
                <NavTitleTypography>Accessible Chart Reader</NavTitleTypography>
            </Box>
            <Button
                variant='outlined'
                size='small'
                onClick={handleSignOut}
                aria-label='Sign out of Accessible Chart Reader'
                sx={navSignOutSx}>
                Sign out
            </Button>
        </Box>
    );
}
